import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { initUser, MMU_USER_INFO_ENDPOINT, MmuAuthModule, MmuPlanPermissionService, MmuUserService } from './auth/public_api';
import { MmuCookiePreferencesService, MmuCookiesModule } from './cookies/public_api';
import { MmuDashboardModule } from './dashboard/public_api';
import { MmuFaviconService } from './favicons/public_api';
import { MmuFeatureFlagsModule, MmuFeatureFlagsService } from './feature-flags';
import { MmuFooterModule } from './footer/public_api';
import { MmuFormattersModule } from './formatters/public_api';
import { mmuTranslateHandler } from './i18n/mmu-translate-handler';
import { MmuWebComponentsModule } from './web-components/public_api';
import { MmuAnalyticsModule } from './analytics/mmu-analytics.module';
import { MmuConnectionService } from './connection/service/mmu-connection.service';
import { MmuDevicesModule } from './devices/mmu-devices.module';
import { MmuKeepAliveService } from './keep-alive';

const ALL_MODULES = [
  MmuAuthModule,
  MmuCookiesModule,
  MmuDashboardModule,
  MmuFeatureFlagsModule,
  MmuFooterModule,
  MmuFormattersModule,
  MmuWebComponentsModule,
  MmuAnalyticsModule,
  MmuDevicesModule
];

export interface MmuModuleConfig {
  userInfoEndpointUrl?: string;
}

const mmuModuleBaseConfig: MmuModuleConfig = {
  userInfoEndpointUrl: '/api/userInfo',
};

@NgModule({
  imports: ALL_MODULES,
  exports: ALL_MODULES
})
export class MmuModule {
  static forRoot(config?: MmuModuleConfig): ModuleWithProviders<MmuModule> {
    // Override base config with user defined settings
    config = { ...mmuModuleBaseConfig, ...config };

    return {
      ngModule: MmuModule,
      providers: [
        MmuFaviconService,
        MmuFeatureFlagsService,
        MmuUserService,
        MmuConnectionService,
        MmuPlanPermissionService,
        CookieService,
        MmuCookiePreferencesService,
        { provide: APP_INITIALIZER, useFactory: initUser, deps: [MmuUserService], multi: true },
        { provide: APP_INITIALIZER, useFactory: mmuTranslateHandler, deps: [TranslateService, CookieService, MmuUserService], multi: true },
        { provide: APP_INITIALIZER, useFactory: (_: MmuFeatureFlagsService) => () => _, deps: [MmuFeatureFlagsService], multi: true },
        // Important: The APP_INITIALIZER factory function must itself return a function as well!
        { provide: APP_INITIALIZER, useFactory: (_: MmuKeepAliveService) => () => _, deps: [MmuKeepAliveService], multi: true },
        { provide: MMU_USER_INFO_ENDPOINT, useValue: config.userInfoEndpointUrl }
      ]
    };
  }
}
